module.exports = __webpack_public_path__ + "img/mafia.2472cc4c.png";